import { useRef } from "react";
import { Upload, Check } from "lucide-react";
import type { UserBrand } from "../../services/settings/userBrands";

export const getBrandLogoUrl = (brand: UserBrand) =>
  brand.logo_dark_url || brand.logo_url || brand.logo_light_url || "";

interface LogoLibraryGridProps {
  logoBrands: UserBrand[];
  loading?: boolean;
  selectedBrandId?: string | null;
  onSelectBrand: (brand: UserBrand) => void;
  onUploadFile: (file: File) => void;
}

// Grid desplegable de la biblioteca de logos ("Subir nuevo" + logos guardados).
export function LogoLibraryGrid({
  logoBrands,
  loading,
  selectedBrandId,
  onSelectBrand,
  onUploadFile,
}: LogoLibraryGridProps) {
  const fileRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <div className="flex max-h-[184px] flex-wrap gap-2 overflow-y-auto">
        <button
          type="button"
          onClick={() => fileRef.current?.click()}
          className="flex h-14 w-14 flex-col items-center justify-center gap-0.5 rounded-xl border-[1.5px] border-dashed border-[#CBD5E1] text-[#64748B] transition-colors hover:border-[#3B4A9F] hover:text-[#3B4A9F]"
        >
          <Upload className="h-3.5 w-3.5" />
          <span className="text-[9px] font-medium leading-none">Subir</span>
        </button>

        {loading ? (
          <div className="flex items-center py-4 text-sm text-[#94A3B8]">Cargando tus logos…</div>
        ) : logoBrands.length === 0 ? (
          <div className="flex items-center py-4 text-sm text-[#94A3B8]">Aún no tienes logos guardados</div>
        ) : (
          logoBrands.map((brand) => {
            const url = getBrandLogoUrl(brand);
            const selected = selectedBrandId === brand.id;
            return (
              <button
                key={brand.id}
                type="button"
                title={brand.name}
                onClick={() => onSelectBrand(brand)}
                className={`relative flex h-14 w-14 items-center justify-center overflow-hidden rounded-xl bg-white transition-colors ${
                  selected ? "border-2 border-[#3B4A9F]" : "border border-[#E2E8F0] hover:border-[#CBD5E1]"
                }`}
              >
                {selected && (
                  <span className="absolute right-0.5 top-0.5 z-10 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-[#3B4A9F] text-white">
                    <Check className="h-2 w-2" />
                  </span>
                )}
                <img src={url} alt={brand.name} className="h-full w-full object-cover" />
              </button>
            );
          })
        )}
      </div>
      <input
        ref={fileRef}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={(e) => {
          const f = e.target.files?.[0];
          if (f) onUploadFile(f);
          e.target.value = "";
        }}
      />
    </>
  );
}
